export default __webpack_public_path__ + "static/media/notificationIcon.f797954d.svg";